<template>
    <b-container fluid class="bv-example-cambio">
        <b-img class="logoo" :src="logo"></b-img>
        <b-card style="max-width: 47rem; " class="mb-22cc">
            <b-row style="margin: -2.2%;">
                <b-col cols="12" sm="12" md="6" lg="6"  class="datosuno">
                <div class="contenidosdatos">
                    <b-card-title>
                        <div class="ingreso-al-sistema-prmm poppins-semi-bold-mine-shaft-20px">{{prmCielum}}</div>
                     </b-card-title>
                        <div class="correo-electrnico poppins-semi-bold-tuatara-14px">{{passworde}}</div>
                        <b-input-group>
                            <b-form-input trim @input="validacionCodiciones()" :type="passwordz" v-model="newpassword" class="campo tm emailll" placeholder="******" :style=" ( this.notifi3 == true  ) ? 'border-top: 2px solid red !important; border-left: 2px solid red !important ; border-bottom: 2px solid red !important' : 'border: 2px solid #ced4da ' "  ></b-form-input>
                            <b-input-group-append class="campoa   eye">
                                <b-input-group-text class="input-group-text-cambio " :style=" (this.notifi3 == true   ) ? 'border-top: 2px solid red !important; border-right: 2px solid red !important ; border-bottom: 2px solid red !important'  : 'border: 2px solid #ced4da ' " @click="visualizarpass()">
                                    <b-icon class="eyes" v-if="passwordz == 'password' " icon="eye" />
                                    <b-icon class="eyes" v-if="passwordz == 'text' " icon="eye-slash" />
                                </b-input-group-text>
                            </b-input-group-append>
                        </b-input-group>
                        <div v-if="this.notifi3 == true " class="ingrese-un-correo-electrnico  margen poppins-normal-alizarin-crimson-12px">{{ campos }}</div>
                        <div class="correo-electrnico poppins-semi-bold-tuatara-14px">{{confirpasswordd}}</div>
                        <b-input-group>
                            <b-form-input trim @input="validacionContrasena()" v-model="confirpassword" :type="passwordd" class="campo tm emailll" placeholder="******"  :style=" (this.notifi2 == true ||this.notifi == true || this.notifi3 == true  ) ? 'border-top: 2px solid red !important; border-left: 2px solid red !important ; border-bottom: 2px solid red !important' : 'border: 2px solid #ced4da ' " ></b-form-input>
                            <b-input-group-append class="campoa  eye">
                            
                                <b-input-group-text class="input-group-text-cambio "  :style=" (this.notifi2 == true ||this.notifi == true || this.notifi3 == true   ) ? 'border-top: 2px solid red !important; border-right: 2px solid red !important ; border-bottom: 2px solid red !important'  : 'border: 2px solid #ced4da ' " @click="visualizarpasss()">
                                    <b-icon class="eyes" v-if="passwordd == 'password' " icon="eye" />
                                    <b-icon class="eyes" v-if="passwordd == 'text' " icon="eye-slash" />
                                </b-input-group-text>
                            </b-input-group-append>
                        </b-input-group>
                        
                        <div v-if="this.notifi3 == true " class="ingrese-un-correo-electrnico poppins-normal-alizarin-crimson-12px">{{ campos }}</div>
                        <div v-if="this.notifi == true && this.notifi2 == false " class="ingrese-un-correo-electrnico poppins-normal-alizarin-crimson-12px">{{ nocoinciden }}</div>
                        <div v-if="this.notifi2 == true   " class="ingrese-un-correo-electrnico poppins-normal-alizarin-crimson-12px">{{ nocondiciones }}</div>
                        <div v-if="apiErrorMessage" class="ingrese-un-correo-electrnico poppins-normal-alizarin-crimson-12px" style="margin-bottom: 5px;">{{ apiErrorMessage }}</div>
                        <div  @click="cambiarPassword()">
                            <b-button block class="boton-ingresoo"  ><span v-if="this.load == false" class="ingresar poppins-semi-bold-white-14px">Enviar</span><div v-if="this.load == true"><b-spinner small></b-spinner><span class="sr-only ingresar poppins-semi-bold-white-14px">Cargando...</span></div></b-button></div>
                </div>
                </b-col>
                <b-col  cols="12" sm="12" md="6" lg="6" >
                    <div class="contenidosdatosdos poppins-normal-tuatara-14px">
                    <p>{{laContraseaDebeC}}</p>
                    <div class="conetnidodes">
                             <div class="chequeo">
                                <input class="form-check-input" type="checkbox" :checked="mini" onclick="return false;"  name="checkbox-1" >
                                 <div class="recordarr poppins-normal-tuatara-14px">{{carateresocho}}</div>
                            </div>
                            <div class="chequeo">
                                <input class="form-check-input" type="checkbox" :checked="datomayus" onclick="return false;"  name="checkbox-1 ">
                                 <div class="recordarr poppins-normal-tuatara-14px">{{caratermayus}}</div>
                            </div>
                            <div class="chequeo">
                                <input class="form-check-input" type="checkbox" :checked="datominus" onclick="return false;"  name="checkbox-1" >
                                 <div class="recordarr poppins-normal-tuatara-14px">{{caraterminus}}</div>
                            </div>
                            <div class="chequeo">
                                <input class="form-check-input" type="checkbox" :checked="datocarater" onclick="return false;"  name="checkbox-1" >
                                 <div class="recordarr poppins-normal-tuatara-14px">{{caraterespecial}}</div>
    
                            </div>
                        <div v-if="this.contraserepetida == true" class="ingrese-una-contraseasg poppins-normal-white-12px">Nueva Contraseña utilizada con anterioridad, digite otra contraseña. Recuerde que no debe emplear contraseñas que ha registrado en las 3 ocasiones anteriores.</div>
                        </div>
                  
                    </div>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import { RepositoryFactory } from "../repositories/RepositoryFactory";

const login = RepositoryFactory.get("login");
const password = RepositoryFactory.get("recoverpass");
export default {
    name: "CambioContrasea",
    components: {  },

    props: [
        "logo",
        "prmCielum",
        "passworde",
        "confirpasswordd",
        "children",
        "intentosContra",
        "laContraseaDebeC",
          "carateresocho",
        "caratermayus",
        "caraterminus",
        "caraterespecial",
        "nocondiciones",
        "nocoinciden",
        "campos"
       
    ],
    data() {
        return {
            newpassword: "",
            confirpassword: "",
            notifi: false,
            notifi2: false,
            notifi3:false,
            mini: false,
            mayus: "",
            minus: "",
            datomayus: false,
            datominus: false,
            carater: "",
            datocarater: false,
            passwordz: "password",
            passwordd: "password",
            token: "",
            tokenu: "",
            load:false,
            tokend: "",
            contraserepetida:false,
            apiErrorMessage: null,
        }
    },
    
    async created() {
        const url = window.location.search;
        this.token = url.replace("?token=", "")
        var vt= /%24/g;
        this.tokenu = this.token.replace(vt, "$")
        var vtu = /%2F/g;
        this.tokend = this.tokenu.replace(vtu, "/")
       
         
       
        const response = await login.validateToken({
            "token": this.tokend,
            
        }).catch(async (error) => {
          
            this.$router.push('/error401');
        });
    },
    methods: {
    
        async validacionContrasena() {
            if (this.newpassword != this.confirpassword) {
                this.notifi = true;
                this.notifi3 = false;
            } else {
                this.notifi = false;
            }
        },
        async cambiarPassword() {
            if (this.newpassword == "" || this.confirpassword =="") {
                this.notifi3 = true;
            } else {
                this.notifi = false;
                if (this.newpassword == "" || this.confirpassword == "" || this.datocarater == false || this.datominus == false || this.datomayus == false || this.mini == false) {
                    this.notifi2 = true;
                    this.notifi3 = false;
                    setTimeout(() => {
                        this.$router.go('/CambioContrasea');
                    }, 4000);

                } else {
                    this.notifi2 = false;
                    this.load=true;
                    const response = await password.cambioPassword({
                        "password": this.newpassword,
                        "token": this.tokend
                    }).then((respuesta) => {
                        this.$router.push({ name: 'Modal', params: { message: "La contraseña ha sido cambiada exitosamente.", massageboton:"ir al inicio de sesión",actions:"/login", } });
                        this.isPopup = true;
                    }).catch((error) => {
                        this.load = false;
                        const msg = error.response && error.response.data && error.response.data.error
                            ? error.response.data.error.message
                            : 'Error al cambiar la contraseña';
                        this.apiErrorMessage = msg;
                        if(error.response && error.response.data && error.response.data.error && error.response.data.error.code == "TE400"){
                            this.contraserepetida = true
                        }
                    });
                }



            }

        },
        async validacionCodiciones() {
            this.mayus = /[A-Z]/;
            this.datomayus = this.mayus.test(this.newpassword);
            this.minus = /[a-z]/;
            this.datominus = this.minus.test(this.newpassword);
            this.carater = /[;:\.,!¡\?¿@#\$%\^&\-_+=/>*<"\(\)\[\]\{\}]/;
            this.datocarater = this.carater.test(this.newpassword);
            if (this.newpassword.length >= 8) {
                this.mini = true;
                if (this.datomayus == true || this.datominus == true || this.datocarater == true) {


                } else {
                    this.datocarater = false;
                    this.datominus = false;
                    this.datomayus = false;


                }
            } else {
                this.mini = false;
            }
        },
        async validacion() {
            if (this.newpassword == "" || this.confirpassword == "" || this.datocarater == false || this.datominus == false || this.datomayus == false || this.mini == false) {
                this.notifi2 = true;
                setTimeout(() => {
                    this.$router.go('/CambioContrasea');
                }, 4000);

            } else {
                this.notifi2 = false;
            }
        },
        async visualizarpass() {
            if (this.passwordz == "password") {
                this.passwordz = "text";
            } else {
                this.passwordz = "password";
            }
        },
        async visualizarpasss() {
            if (this.passwordd == "password") {
                this.passwordd = "text";
            } else {
                this.passwordd = "password";
            }
        }

    }
};
</script>

<style>
.margen{
    margin-top: -10%;
}
.conetnidodes{
      margin-top: 10%;
    }
.form-control:focus {
  box-shadow: none !important;
  border: 2px solid var(--blue-violet) !important;
}
.chequeo{
    margin-bottom: 5%;
}
.recordarr {
    letter-spacing: 0;
    line-height: 27px;
}
.form-check-input{
    border: 1px solid !important;
    border-color: var(--hawkes-blue) !important;
    border-radius: 4px !important;
    width: 20px !important;
    height: 19px !important;
    margin-right:3%;
    cursor: pointer;
    float: left;
}
  .input-group-text-cambio {
   margin-top:25%;
    margin-bottom:10%;
    height: 61.4%;
    border: none !important; 
    border-radius: 0 !important;
    background-color: white !important;
    border-bottom: 1px solid  var(--hawkes-blue) !important;
    border-top: 1px solid  var(--hawkes-blue) !important;
    border-right: 1px solid  var(--hawkes-blue) !important;
    border-top-right-radius: 10px !important;
    border-bottom-right-radius: 10px !important;
}
.emailll{ 
    border-bottom: 1px solid var(--hawkes-blue) !important;
    border-top: 1px solid var(--hawkes-blue) !important;
    border-left: 1px solid var(--hawkes-blue) !important; 
    border-right: 1px solid white !important;
    border-radius: 0 !important;
    border-top-left-radius: 10px !important;
    border-bottom-left-radius: 10px !important;
    
}
.custom-control , .custom-checkbox{
display: flex !important;
   align-items: center !important;
       margin-top: 6% !important;
}
.bv-example-cambio {
    /* background-color: var(--blue-violet);
    margin: 0;
    max-width: 100% !important;
    height: 753px !important;
    text-align: center; */
    background-color: var(--blue-violet);
     height: 100vh;
       text-align: center;
}
.ingrese-una-contraseasg {
  background-color: var(--alizarin-crimson);
    border-radius: 10px;
    margin-top:7%;
    padding:5%;
    text-align:center;
    line-height: 12px;
}
.logoo {
    margin-top: 3%;
}

.mb-22cc {
    margin-left: 25%;
    padding: 0%;
    background-color: white !important;
    border-radius: 10px !important;
    margin-top: 6%;
    border-color:transparent !important ;
}
.card-body {
    padding: 0 ;
    }
.datosuno{
   background-color: var(--zircon) !important; 
   border-top-left-radius: 10px;
   border-bottom-left-radius: 10px;
   text-align:left;
   border-right:1px solid gainsboro;
}

.contenidosdatos{
    margin: 10%;
}
.contenidosdatosdos{
    margin: 11% 7%;
    text-align:left;
}
.boton-ingresoo{
    margin-top:7%;
    width:100%;
    background-color: var(--blue-violet) !important;
    border-radius: 10px !important;
    height: 50px;
    border-color:transparent !important ;
}
.boton-ingresoo:hover{
    background: var(--hover) !important;
}
.ingreso-al-sistema-prmm { 
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
  margin-bottom:10%;
 
}
#checkbox-11{
    background-color: var(--white) !important;
    border: 1px solid !important;
    border-color: var(--hawkes-blue) !important;
    border-radius: 4px !important;
    width: 20px;
    height: 19px;
    margin-right:3%;
}

@media (max-width: 1922px) {
/* .bv-example-cambio {
    height: 969px !important;
} */
.mb-22cc {
    margin-left: 31%;
}
}
@media (max-width: 1540px) {
/* .bv-example-cambio {
    height: 753px !important;
} */
.mb-22cc {
    margin-left: 25%;
}
}
@media (max-width: 1370px) {
    /* .input-group-text {
        margin-top: 22% !important;
    height: 58.4% !important;
} */
    .logoo {
    margin-top: 2%;
    width: 20%;
} 
.mb-22cc {
    margin-left: 24%;
    margin-top: 4%;
}
}
@media (max-width: 1280px) {
    /* .bv-example-cambio {
    height: 609px !important;
} */
.mb-22cc {
    margin-left: 20%;
    margin-top: 4%;
}
}
@media (max-width: 669px) {
    .mb-22cc {
    margin-left: 0% !important;
    margin-top: 3%;
}
.chequeo {
    margin-bottom: 5% !important;
}
.conetnidodes {
    margin-top: 5% !important;
}
}
@media (max-width: 1100px) {
    /* .bv-example-cambio {
    height: 507px !important;
} */
  .logoo {
    margin-top: 3%;
    width: 16%;
}
.mb-22cc {
    margin-left: 8%;
    margin-top: 3%;
}
}

</style>
